export default __webpack_public_path__ + "static/media/Crow Shadow Sash.24a07ad1.jpg";